import { render, staticRenderFns } from "./PaymentsTabs.vue?vue&type=template&id=ec003bf0&scoped=true"
var script = {}
import style0 from "./PaymentsTabs.vue?vue&type=style&index=0&id=ec003bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec003bf0",
  null
  
)

export default component.exports